import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { WorkspaceGuard } from '../core/guards/workspace.guard';
import Enums from "../shared/enum/enums";
import Workspace = Enums.Workspace;
import {StartupResolver} from '../core/resolver/startup.resolve';

const routes: Routes = [
  { path: '', redirectTo: Workspace.sbb_eigentumsflaeche, pathMatch: 'full' },
  {
    path: ':workspace',
    component: HomeComponent,
    canActivate: [WorkspaceGuard],
    resolve: {
      startup: StartupResolver
    },
    loadChildren: () => import('./edit-info-routing/edit-info.module').then(mod => mod.EditInfoModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PageRoutingModule {}
